<div sxCol sxGap='10px' sxRadius="medium" sxBackground="light">

  @if (templates$ | async; as templates) {
  <ion-list sxBackground="light">

    @if (isMultiSelection && isShowSelectAll) {
    <ion-item>
      <ion-checkbox justify="space-between" sxTextSize="small" [(ngModel)]="isAllSelected"
        (click)="selectAllToggle()">All</ion-checkbox>
    </ion-item>
    }

    @for (template of templates; track template._id) {
    <ion-item [detail]="!isMultiSelection" button="" sxCapitalize="" (click)="onTemplateClicked(template)"
      [class.disabled]="isAllSelected || templateNeedsSetup(template)"
      [class.selected]="!isMultiSelection && selectedTemplateId === template._id">
      @if (!isMultiSelection) {
      <ion-label>{{ template.purpose }}</ion-label>
      }
      @if (isMultiSelection) {
      <ion-checkbox [checked]='isChecked(template)' [disabled]="templateNeedsSetup(template)"
        (ionChange)="onCheckboxClick(template, $event)" justify="space-between" sxTextSize="small">
        <div sxCol sxGap="2px">
          <span>{{ template.purpose }}</span>
          @if (templateNeedsSetup(template)) {
          <span sxColor="danger" sxTextSize="small" sxTextWeight="bold">
            ⚠ Needs Setup - Add Documents First
          </span>
          }
        </div>
      </ion-checkbox>
      }
    </ion-item>
    }

    @if (sharedTemplates$ | async; as sharedTemplates) {

    @for (template of sharedTemplates; track template._id) {
    <ion-item [detail]="true" button="" sxCapitalize="" (click)="onTemplateClicked(template)"
      [class.disabled]="templateNeedsSetup(template)"
      [class.selected]="!isMultiSelection && selectedTemplateId === template._id">
      @if (!isMultiSelection) {
      <ion-label>
        <div sxRow sxAlign="center" sxGap="8px">
          <span>{{template.purpose}}</span>
          @if (templateNeedsSetup(template)) {
          <span sxColor="warning" sxTextSize="x-small" sxTextWeight="bold" sxPadding="2px 8px" sxRadius="small"
            sxBackground="warning-light" sxDisplay="inline-block">
            Needs Setup
          </span>
          }
        </div>
      </ion-label>
      }
      @if (isMultiSelection) {
      <ion-checkbox [checked]='isChecked(template)' [disabled]="templateNeedsSetup(template)"
        (ionChange)="onCheckboxClick(template, $event)" justify="space-between">
        <div sxCol sxGap="2px">
          <span>{{ template.purpose }}</span>
          @if (templateNeedsSetup(template)) {
          <span sxColor="warning" sxTextSize="x-small" sxTextWeight="bold">
            ⚠ Needs Setup - Add Documents First
          </span>
          }
        </div>
      </ion-checkbox>
      }
    </ion-item>
    }
    }
  </ion-list>
  }

</div>